import { render, staticRenderFns } from "./AddressField.vue?vue&type=template&id=5e456e4b&"
import script from "./AddressField.vue?vue&type=script&lang=js&"
export * from "./AddressField.vue?vue&type=script&lang=js&"
import style0 from "./AddressField.vue?vue&type=style&index=0&id=5e456e4b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports